import { useEffect, useState } from "react";
import Logo from "./components/Logo";
import { FaDatabase, FaBolt, FaEnvelope, FaMap, FaChartBar, FaRobot } from "react-icons/fa6";

// Ã¢”â‚¬Ã¢”â‚¬ Smooth scroll helper Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬
function scrollTo(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

// Ã¢”â‚¬Ã¢”â‚¬ App screenshot mockup Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬
function AppMockup() {
  const cards = [
    { name: "OSLO TANNLEGEVAKT AS", city: "Oslo, Norway", score: 80, label: "HOT", color: "#ef4444", bg: "#fef2f2", tag: true },
    { name: "NORDIC BAKERY LTD", city: "Bergen, Norway", score: 70, label: "GOOD", color: "#f59e0b", bg: "#fffbeb", tag: true },
    { name: "STAVANGER DESIGN STUDIO", city: "Stavanger, Norway", score: 65, label: "GOOD", color: "#f59e0b", bg: "#fffbeb", tag: true },
    { name: "BERGEN RÃƒËœRLEGGER AS", city: "Bergen, Norway", score: 75, label: "GOOD", color: "#f59e0b", bg: "#fffbeb", tag: true },
    { name: "TRONDHEIM CAFÃƒâ€° BAR", city: "Trondheim, Norway", score: 68, label: "GOOD", color: "#f59e0b", bg: "#fffbeb", tag: false },
    { name: "OSLO FITNESS CLUB", city: "Oslo, Norway", score: 62, label: "GOOD", color: "#f59e0b", bg: "#fffbeb", tag: true },
  ];

  return (
    <div style={{
      background: "white", borderRadius: 14, border: "1px solid #e2e8f0",
      overflow: "hidden", boxShadow: "0 24px 64px rgba(15,23,42,0.12)",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      {/* Browser bar */}
      <div style={{ background: "#f1f5f9", padding: "8px 14px", display: "flex", alignItems: "center", gap: 6, borderBottom: "1px solid #e2e8f0" }}>
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fca5a5", display: "inline-block" }} />
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fde68a", display: "inline-block" }} />
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#a7f3d0", display: "inline-block" }} />
        <div style={{ marginLeft: 10, background: "white", borderRadius: 5, padding: "3px 14px", fontSize: 11, color: "#94a3b8", border: "1px solid #e2e8f0", flex: 1, maxWidth: 260 }}>
          waveprospect.devndespro.com
        </div>
      </div>

      {/* App header */}
      <div style={{ background: "white", padding: "10px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #e2e8f0" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Logo
            alt="WaveProspect"
            style={{
              height: 30,
              width: "auto",
              maxWidth: 145,
              objectFit: "contain"
            }}
          />
        </div>
        <div style={{ display: "flex", gap: 4 }}>
          {["Find Leads", "Paste", "Pipeline"].map((t, i) => (
            <div key={t} style={{
              padding: "5px 12px", borderRadius: 0, fontSize: 11, fontWeight: 600,
              background: i === 2 ? "#6366f1" : "transparent",
              color: i === 2 ? "white" : "#64748b",
              cursor: "pointer",
            }}>{t}{i === 2 && <span style={{ marginLeft: 5, background: "rgba(255,255,255,0.25)", borderRadius: 99, padding: "1px 5px", fontSize: 9 }}>20</span>}</div>
          ))}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 20, padding: "3px 10px 3px 4px" }}>
          <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#6366f1", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 700 }}>K</div>
          <span style={{ fontSize: 11, fontWeight: 600, color: "#16a34a" }}>Gmail on</span>
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#22c55e" }} />
        </div>
      </div>

      {/* Stats bar */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)", background: "white", borderBottom: "1px solid #e2e8f0", margin: "0 16px 0", border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden", marginTop: 10, marginBottom: 10, marginLeft: 16, marginRight: 16 }}>
        {[
          { label: "Total leads", sub: "All time", num: "20", color: "#0f172a" },
          { label: "Hot", sub: "High intent", num: "1", color: "#ef4444" },
          { label: "Good", sub: "Warm leads", num: "19", color: "#f59e0b" },
          { label: "No website", sub: "Opportunity", num: "20", color: "#7c3aed" },
          { label: "Contacted", sub: "In progress", num: "0", color: "#3b82f6" },
          { label: "Won", sub: "Closed deals", num: "0", color: "#10b981" },
        ].map((s, i) => (
          <div key={i} style={{ padding: "10px 12px", borderRight: i < 5 ? "1px solid #e2e8f0" : "none" }}>
            <div style={{ fontSize: 10, color: "#64748b", fontWeight: 500, marginBottom: 2 }}>{s.label}</div>
            <div style={{ fontSize: 9, color: "#94a3b8", marginBottom: 4 }}>{s.sub}</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: s.color, lineHeight: 1 }}>{s.num}</div>
          </div>
        ))}
      </div>

      {/* Cards grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, padding: "0 16px 16px" }}>
        {cards.map((c, i) => (
          <div key={i} style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 10, padding: "12px 13px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#0f172a", lineHeight: 1.3, flex: 1, paddingRight: 6 }}>{c.name}</div>
              <div style={{ background: c.bg, color: c.color, borderRadius: 6, padding: "4px 7px", textAlign: "center", flexShrink: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 800, lineHeight: 1 }}>{c.score}</div>
                <div style={{ fontSize: 7, fontWeight: 700, textTransform: "uppercase" }}>{c.label}</div>
              </div>
            </div>
            <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 2 }}>Ã°Å¸“Â {c.city}</div>
            <div style={{ borderTop: "1px solid #f1f5f9", marginTop: 8, paddingTop: 7, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 10, color: "#94a3b8", display: "flex", alignItems: "center", gap: 4 }}>
                <span style={{ width: 5, height: 5, borderRadius: "50%", background: "#94a3b8", display: "inline-block" }} /> New
              </span>
              {c.tag && <span style={{ background: "#fef9c3", color: "#854d0e", border: "1px solid #fde68a", fontSize: 9, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>No Site</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


function FeatureCard({ icon: Icon, title, desc, accent }) {
  return (
    <div style={{
      padding: "28px 28px 24px",
      border: "1px solid #e2e8f0",
      borderRadius: 12,
      background: "white",
      transition: "transform 0.15s, box-shadow 0.15s",
      cursor: "default",
    }}
    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(15,23,42,0.08)"; }}
    onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
    >
      <div style={{ width: 44, height: 44, borderRadius: 10, background: accent + "18", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, marginBottom: 16, color: accent }}><Icon /></div>
      <div style={{ fontSize: 15, fontWeight: 700, color: "#0f172a", marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 14, color: "#64748b", lineHeight: 1.65 }}>{desc}</div>
    </div>
  );
}

// Ã¢”â‚¬Ã¢”â‚¬ Testimonial card Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬
function TestimonialCard({ name, role, text, avatar }) {
  return (
    <div style={{ padding: "24px", border: "1px solid #e2e8f0", borderRadius: 12, background: "white" }}>
      <div style={{ fontSize: 13, color: "#475569", lineHeight: 1.7, marginBottom: 20 }}>"{text}"</div>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#6366f1", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700 }}>{avatar}</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{name}</div>
          <div style={{ fontSize: 12, color: "#94a3b8" }}>{role}</div>
        </div>
      </div>
    </div>
  );
}

// Ã¢”â‚¬Ã¢”â‚¬ Main Landing Page Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬Ã¢”â‚¬
export default function LandingPage({ onLaunch }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handle = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handle);
    return () => window.removeEventListener("scroll", handle);
  }, []);

  const navLinks = [
    { label: "Features", id: "features" },
    { label: "How it works", id: "how" },
    { label: "Countries", id: "countries" },
    { label: "Pricing", id: "pricing" },
  ];

  return (
    <div style={{ fontFamily: "'DM Sans', -apple-system, sans-serif", color: "#0f172a", background: "#fff", lineHeight: 1.6 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Serif+Display&display=swap" rel="stylesheet" />

      {/* Ã¢”â‚¬Ã¢”â‚¬ NAV Ã¢”â‚¬Ã¢”â‚¬ */}
      <nav style={{
        position: "sticky", top: 0, zIndex: 100,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 40px", height: 60,
        background: scrolled ? "rgba(255,255,255,0.95)" : "white",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: `1px solid ${scrolled ? "#e2e8f0" : "#f1f5f9"}`,
        transition: "all 0.2s",
      }}>
<div style={{ display: "flex", alignItems: "center" }}>
  <Logo
    alt="WaveProspect"
    style={{
      display: "block",
      height: 48,
      width: "auto",
      maxWidth: 220,
      objectFit: "contain",
      cursor: "pointer"
    }}
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
  />
</div>

        {/* Desktop nav */}
        <div style={{ display: "flex", gap: 28, alignItems: "center" }} className="nav-desktop">
          {navLinks.map(l => (
            <button key={l.id} onClick={() => scrollTo(l.id)} style={{ background: "none", border: "none", fontSize: 14, fontWeight: 500, color: "#475569", cursor: "pointer", padding: 0, transition: "color 0.15s" }}
              onMouseEnter={e => e.target.style.color = "#0f172a"}
              onMouseLeave={e => e.target.style.color = "#475569"}
            >{l.label}</button>
          ))}
        </div>

        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <button onClick={onLaunch} style={{ background: "none", border: "1px solid #e2e8f0", color: "#475569", padding: "7px 18px", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all 0.15s" }}
            onMouseEnter={e => { e.target.style.borderColor = "#6366f1"; e.target.style.color = "#6366f1"; }}
            onMouseLeave={e => { e.target.style.borderColor = "#e2e8f0"; e.target.style.color = "#475569"; }}
          >Sign in</button>
          <button onClick={onLaunch} style={{ background: "#6366f1", color: "white", border: "none", padding: "8px 20px", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all 0.15s", boxShadow: "0 2px 8px rgba(99,102,241,0.3)" }}
            onMouseEnter={e => { e.target.style.background = "#4f46e5"; e.target.style.transform = "translateY(-1px)"; }}
            onMouseLeave={e => { e.target.style.background = "#6366f1"; e.target.style.transform = "translateY(0)"; }}
          >Get started free</button>
        </div>
      </nav>

      {/* Ã¢”â‚¬Ã¢”â‚¬ HERO Ã¢”â‚¬Ã¢”â‚¬ */}
      <section style={{ maxWidth: 780, margin: "0 auto", textAlign: "center", padding: "90px 24px 60px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 7, background: "#eef2ff", color: "#4338ca", border: "1px solid #c7d2fe", borderRadius: 999, padding: "4px 14px 4px 8px", fontSize: 13, fontWeight: 600, marginBottom: 28 }}>
          <span style={{ background: "#6366f1", color: "white", borderRadius: 999, padding: "1px 8px", fontSize: 11 }}>Free</span>
          No credit card · No signup required
        </div>

        <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(38px,6vw,60px)", lineHeight: 1.08, letterSpacing: "-1.5px", marginBottom: 20, color: "#0f172a" }}>
          Find B2B leads from<br />
          <span style={{ color: "#6366f1" }}>15 countries</span> in seconds
        </h1>

        <p style={{ fontSize: 18, color: "#475569", lineHeight: 1.7, maxWidth: 540, margin: "0 auto 36px" }}>
          WaveProspect searches live business registries, Google Maps, and AI to surface your best prospects — scored, qualified, and ready to contact.
        </p>

        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap", marginBottom: 14 }}>
          <button onClick={onLaunch} style={{ background: "#6366f1", color: "white", border: "none", padding: "14px 30px", borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 14px rgba(99,102,241,0.35)", transition: "all 0.15s" }}
            onMouseEnter={e => { e.currentTarget.style.background = "#4f46e5"; e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 8px 22px rgba(99,102,241,0.4)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#6366f1"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(99,102,241,0.35)"; }}
          >Start finding leads</button>
          <button onClick={() => scrollTo("how")} style={{ background: "white", color: "#0f172a", border: "1px solid #e2e8f0", padding: "14px 28px", borderRadius: 9, fontSize: 15, fontWeight: 600, cursor: "pointer", transition: "all 0.15s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; }}
          >See how it works</button>
        </div>
        <p style={{ fontSize: 12, color: "#94a3b8" }}>Free forever · Works in your browser · No installation needed</p>
      </section>

      {/* Ã¢”â‚¬Ã¢”â‚¬ APP SCREENSHOT Ã¢”â‚¬Ã¢”â‚¬ */}
      <div style={{ maxWidth: 1000, margin: "0 auto 80px", padding: "0 24px" }}>
        <AppMockup />
      </div>

      {/* Ã¢”â‚¬Ã¢”â‚¬ STATS STRIP Ã¢”â‚¬Ã¢”â‚¬ */}
      <div style={{ background: "#f8fafc", borderTop: "1px solid #e2e8f0", borderBottom: "1px solid #e2e8f0", padding: "40px 24px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 0 }}>
          {[
            { num: "15", label: "Countries supported" },
            { num: "100%", label: "Free to use" },
            { num: "Live", label: "Real business data" },
            { num: "AI", label: "Powered outreach" },
          ].map((s, i) => (
            <div key={i} style={{ textAlign: "center", padding: "16px 20px", borderRight: i < 3 ? "1px solid #e2e8f0" : "none" }}>
              <div style={{ fontSize: 34, fontWeight: 800, color: "#6366f1", letterSpacing: "-1px", lineHeight: 1 }}>{s.num}</div>
              <div style={{ fontSize: 13, color: "#64748b", marginTop: 6 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Ã¢”â‚¬Ã¢”â‚¬ FEATURES Ã¢”â‚¬Ã¢”â‚¬ */}
      <section id="features" style={{ maxWidth: 1100, margin: "0 auto", padding: "80px 24px" }}>
        <div style={{ textAlign: "center", marginBottom: 52 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#6366f1", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>Features</div>
          <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(28px,4vw,40px)", lineHeight: 1.2, letterSpacing: "-0.5px", marginBottom: 12 }}>Everything to close more deals</h2>
          <p style={{ fontSize: 16, color: "#64748b", maxWidth: 480, margin: "0 auto" }}>From finding leads to sending the first email Ã¢â‚¬” all in one free tool.</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16 }}>
          <FeatureCard icon={FaDatabase} accent="#6366f1" title="Live business data" desc="Search real company registries in Norway, UK, Denmark and more. Always fresh from official government sources." />
          <FeatureCard icon={FaBolt} accent="#f59e0b" title="AI lead scoring" desc="Every lead gets an automatic score based on size, industry, and signals like missing websites. Know who to contact first." />
          <FeatureCard icon={FaEnvelope} accent="#10b981" title="One-click outreach" desc="Generate personalised cold emails with AI and send directly from your Gmail Ã¢â‚¬” no copy-pasting, no switching tabs." />
          <FeatureCard icon={FaMap} accent="#3b82f6" title="Google Maps search" desc="Find local businesses in USA, India, UAE, Australia and 10 more countries Ã¢â‚¬” perfect for service-based outreach." />
          <FeatureCard icon={FaChartBar} accent="#8b5cf6" title="Pipeline tracking" desc="Move leads from New Contacted Interested Won. See your entire pipeline at a glance with live stats." />
          <FeatureCard icon={FaRobot} accent="#ef4444" title="AI qualification" desc="Let AI analyse each lead and recommend whether to pursue, refer out, or skip Ã¢â‚¬” with reasons and project value estimate." />
        </div>
      </section>

      {/* Ã¢”â‚¬Ã¢”â‚¬ HOW IT WORKS Ã¢”â‚¬Ã¢”â‚¬ */}
      <section id="how" style={{ background: "#f8fafc", borderTop: "1px solid #e2e8f0", padding: "80px 24px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 52 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#6366f1", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>How it works</div>
            <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(28px,4vw,40px)", lineHeight: 1.2, letterSpacing: "-0.5px" }}>From zero to outreach in 3 steps</h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 40 }}>
            {[
              { n: "1", title: "Pick your market", desc: "Select countries, industries, and cities. Choose from live registries or Google Maps Ã¢â‚¬” or let AI generate global leads." },
              { n: "2", title: "Get scored leads", desc: "WaveProspect searches, scores, and surfaces the best opportunities. Businesses with no website score highest." },
              { n: "3", title: "Send the email", desc: "Generate a personalised message with AI, edit if needed, and send directly from your Gmail in one click." },
            ].map(s => (
              <div key={s.n} style={{ textAlign: "center" }}>
                <div style={{ width: 48, height: 48, background: "#6366f1", color: "white", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, fontWeight: 800, margin: "0 auto 18px" }}>{s.n}</div>
                <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>{s.title}</div>
                <div style={{ fontSize: 14, color: "#64748b", lineHeight: 1.65 }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ã¢”â‚¬Ã¢”â‚¬ TESTIMONIALS Ã¢”â‚¬Ã¢”â‚¬ */}
      <section style={{ maxWidth: 1000, margin: "0 auto", padding: "80px 24px" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#6366f1", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>Testimonials</div>
          <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(28px,4vw,36px)", lineHeight: 1.2, letterSpacing: "-0.5px" }}>Freelancers love it</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16 }}>
          <TestimonialCard avatar="M" name="Marta K." role="Web designer, Warsaw" text="I found 40 local businesses without websites in 10 minutes. Landed 2 clients in my first week of using it." />
          <TestimonialCard avatar="J" name="James T." role="Digital agency, London" text="The Gmail integration is a game-changer. I send 20 cold emails a day directly from the app. Conversion rate is solid." />
          <TestimonialCard avatar="S" name="Sven L." role="Freelancer, Stockholm" text="Norway registry + AI scoring is incredibly accurate. I only reach out to businesses that are actually worth pursuing." />
        </div>
      </section>

      {/* Ã¢”â‚¬Ã¢”â‚¬ COUNTRIES Ã¢”â‚¬Ã¢”â‚¬ */}
      <section id="countries" style={{ background: "#f8fafc", borderTop: "1px solid #e2e8f0", padding: "80px 24px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#6366f1", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>Coverage</div>
          <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(28px,4vw,36px)", lineHeight: 1.2, letterSpacing: "-0.5px", marginBottom: 12 }}>15 countries and growing</h2>
          <p style={{ fontSize: 15, color: "#64748b", marginBottom: 36 }}>Live registry data for Norway, UK, Denmark. Google Maps for everywhere else.</p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
            {[
              { code: "no", name: "Norway" }, { code: "gb", name: "United Kingdom" }, { code: "dk", name: "Denmark" },
              { code: "se", name: "Sweden" }, { code: "de", name: "Germany" }, { code: "nl", name: "Netherlands" },
              { code: "us", name: "USA" }, { code: "ca", name: "Canada" }, { code: "au", name: "Australia" },
              { code: "ae", name: "UAE" }, { code: "sa", name: "Saudi Arabia" }, { code: "in", name: "India" },
              { code: "sg", name: "Singapore" }, { code: "za", name: "South Africa" },
            ].map(c => (
              <div key={c.code} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 14px", border: "1px solid #e2e8f0", borderRadius: 7, background: "white", fontSize: 13, fontWeight: 500, transition: "border-color 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = "#6366f1"}
                onMouseLeave={e => e.currentTarget.style.borderColor = "#e2e8f0"}
              >
                <img src={`https://flagcdn.com/20x15/${c.code}.png`} alt={c.name} style={{ width: 20, height: 15, borderRadius: 2 }} />
                {c.name}
              </div>
            ))}
            <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 14px", border: "1px solid #e2e8f0", borderRadius: 7, background: "white", fontSize: 13, fontWeight: 500 }}>Ã°Å¸Å’Â Global AI</div>
          </div>
        </div>
      </section>

      {/* Ã¢”â‚¬Ã¢”â‚¬ PRICING Ã¢”â‚¬Ã¢”â‚¬ */}
      <section id="pricing" style={{ maxWidth: 480, margin: "0 auto", padding: "80px 24px", textAlign: "center" }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#6366f1", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10 }}>Pricing</div>
        <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(28px,4vw,36px)", lineHeight: 1.2, letterSpacing: "-0.5px", marginBottom: 8 }}>Simple, honest pricing</h2>
        <p style={{ fontSize: 15, color: "#64748b", marginBottom: 36 }}>One plan. Everything included. Always free.</p>

        <div style={{ background: "white", border: "2px solid #6366f1", borderRadius: 16, padding: "40px 36px", boxShadow: "0 8px 32px rgba(99,102,241,0.12)" }}>
          <div style={{ background: "#eef2ff", color: "#4338ca", fontSize: 12, fontWeight: 700, padding: "3px 14px", borderRadius: 999, display: "inline-block", marginBottom: 20, letterSpacing: "0.05em", textTransform: "uppercase" }}>Free Forever</div>
          <div style={{ fontSize: 60, fontWeight: 800, letterSpacing: "-2px", lineHeight: 1, marginBottom: 6, color: "#0f172a" }}>$0</div>
          <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 32 }}>No credit card · No limits · No catch</div>

          <div style={{ textAlign: "left", marginBottom: 32 }}>
            {[
              "Unlimited lead searches",
              "15 countries coverage",
              "AI lead scoring & qualification",
              "Gmail integration for outreach",
              "Pipeline tracking & CSV export",
              "AI-generated personalised emails",
              "Hunter.io email finder",
            ].map(f => (
              <div key={f} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: "1px solid #f1f5f9", fontSize: 14 }}>
                <span style={{ color: "#10b981", fontWeight: 700, fontSize: 16 }}>Ã¢Å““</span>
                {f}
              </div>
            ))}
          </div>

          <button onClick={onLaunch} style={{ width: "100%", background: "#6366f1", color: "white", border: "none", padding: "14px", borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 14px rgba(99,102,241,0.3)", transition: "all 0.15s" }}
            onMouseEnter={e => { e.target.style.background = "#4f46e5"; e.target.style.transform = "translateY(-1px)"; }}
            onMouseLeave={e => { e.target.style.background = "#6366f1"; e.target.style.transform = "translateY(0)"; }}
          >Get Started Free</button>
        </div>
      </section>

      {/* Ã¢”â‚¬Ã¢”â‚¬ CTA Ã¢”â‚¬Ã¢”â‚¬ */}
      <section style={{ background: "#0f172a", padding: "80px 24px", textAlign: "center" }}>
        <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: "clamp(28px,4vw,42px)", color: "white", lineHeight: 1.2, letterSpacing: "-0.5px", marginBottom: 14 }}>Start finding leads today</h2>
        <p style={{ fontSize: 16, color: "#94a3b8", marginBottom: 32, maxWidth: 440, margin: "0 auto 32px" }}>Join freelancers and agencies using WaveProspect to find clients across 15 countries.</p>
        <button onClick={onLaunch} style={{ background: "white", color: "#0f172a", border: "none", padding: "14px 32px", borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: "pointer", transition: "all 0.15s" }}
          onMouseEnter={e => { e.target.style.background = "#f1f5f9"; e.target.style.transform = "translateY(-1px)"; }}
          onMouseLeave={e => { e.target.style.background = "white"; e.target.style.transform = "translateY(0)"; }}
        >Launch WaveProspect</button>
      </section>

      {/* Ã¢”â‚¬Ã¢”â‚¬ FOOTER Ã¢”â‚¬Ã¢”â‚¬ */}
      <footer style={{ background: "#0f172a", borderTop: "1px solid #1e293b", padding: "24px 40px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Logo
            alt="WaveProspect"
            style={{
              height: 32,
              width: "auto",
              maxWidth: 160,
              objectFit: "contain"
            }}
          />
        </div>
        <p style={{ fontSize: 12, color: "#475569" }}>© 2026 WaveProspect · Free B2B lead generation</p>
      </footer>

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
        }
      `}</style>
    </div>
  );
}


